define("checkout/components/payment/payment-method/index", ["exports", "@ember/component", "ember-concurrency/async-arrow-runtime", "@ember/debug", "@ember/object", "@ember/service", "@glimmer/component", "@glimmer/tracking", "ember-concurrency", "@ember/template-factory"], function (_exports, _component, _asyncArrowRuntime, _debug, _object, _service, _component2, _tracking, _emberConcurrency, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7;
  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/async-arrow-runtime",0,"ember-cli-htmlbars",0,"@ember/debug",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"@glimmer/tracking",0,"ember-concurrency",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{#if this.showSavedCard}}
    <div class="u--row u--row--noCollapse u--m__t__md">
      <div class="u--col__8">
        <p class="u--text--bold u--m__b__xs">{{t "plans.checkout.card.title"}}</p>
        <p class="u--m__b__xs dd-privacy-mask">
          {{t "plans.checkout.card.summary" brand=@paymentMethod.card.brand last4=@paymentMethod.card.last4}}
        </p>
        <p class="u--m__0 dd-privacy-mask">
          {{t "plans.checkout.card.expiration" expiration=@paymentMethod.card.exp_month}}/{{@paymentMethod.card.exp_year}}
        </p>
      </div>
      <div class="u--col__4 u--text--right">
        <Shared::Ui::Button
          @isDisabled={{this.isEditDisabled}}
          @onClick={{this.toggleEditing}}
          @text={{t "shared_words.edit"}}
          @variant="outline"
        />
      </div>
    </div>
  {{else}}
    {{! Note: Payment Element used for both new subscriptions and mange/edit/upgrade  }}
    <Payment::StripePaymentElement
      @label={{@label}}
      @onChange={{this.onStripePaymentElementChange}}
      @planType={{@planType}}
    />
    {{#if this.isEditing}}
      <Shared::Ui::Button
        @isDisabled={{not this.canSave}}
        @onClick={{perform this.savePaymentElement}}
        @text={{t "checkout.payment.update_button"}}
        class="tCH--btn--primary o--btn--block u--m__b__s"
      />
      <Shared::Ui::Button
        @onClick={{this.toggleEditing}}
        @text={{t "shared_words.cancel"}}
        @variant="outline"
        class="o--btn--block"
      />
    {{/if}}
  {{/if}}
  */
  {
    "id": "91+2qisd",
    "block": "[[[41,[30,0,[\"showSavedCard\"]],[[[1,\"  \"],[10,0],[14,0,\"u--row u--row--noCollapse u--m__t__md\"],[12],[1,\"\\n    \"],[10,0],[14,0,\"u--col__8\"],[12],[1,\"\\n      \"],[10,2],[14,0,\"u--text--bold u--m__b__xs\"],[12],[1,[28,[35,1],[\"plans.checkout.card.title\"],null]],[13],[1,\"\\n      \"],[10,2],[14,0,\"u--m__b__xs dd-privacy-mask\"],[12],[1,\"\\n        \"],[1,[28,[35,1],[\"plans.checkout.card.summary\"],[[\"brand\",\"last4\"],[[30,1,[\"card\",\"brand\"]],[30,1,[\"card\",\"last4\"]]]]]],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,2],[14,0,\"u--m__0 dd-privacy-mask\"],[12],[1,\"\\n        \"],[1,[28,[35,1],[\"plans.checkout.card.expiration\"],[[\"expiration\"],[[30,1,[\"card\",\"exp_month\"]]]]]],[1,\"/\"],[1,[30,1,[\"card\",\"exp_year\"]]],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n    \"],[10,0],[14,0,\"u--col__4 u--text--right\"],[12],[1,\"\\n      \"],[8,[39,2],null,[[\"@isDisabled\",\"@onClick\",\"@text\",\"@variant\"],[[30,0,[\"isEditDisabled\"]],[30,0,[\"toggleEditing\"]],[28,[37,1],[\"shared_words.edit\"],null],\"outline\"]],null],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"]],[]],[[[1,\"  \"],[8,[39,3],null,[[\"@label\",\"@onChange\",\"@planType\"],[[30,2],[30,0,[\"onStripePaymentElementChange\"]],[30,3]]],null],[1,\"\\n\"],[41,[30,0,[\"isEditing\"]],[[[1,\"    \"],[8,[39,2],[[24,0,\"tCH--btn--primary o--btn--block u--m__b__s\"]],[[\"@isDisabled\",\"@onClick\",\"@text\"],[[28,[37,4],[[30,0,[\"canSave\"]]],null],[28,[37,5],[[30,0,[\"savePaymentElement\"]]],null],[28,[37,1],[\"checkout.payment.update_button\"],null]]],null],[1,\"\\n    \"],[8,[39,2],[[24,0,\"o--btn--block\"]],[[\"@onClick\",\"@text\",\"@variant\"],[[30,0,[\"toggleEditing\"]],[28,[37,1],[\"shared_words.cancel\"],null],\"outline\"]],null],[1,\"\\n\"]],[]],null]],[]]]],[\"@paymentMethod\",\"@label\",\"@planType\"],false,[\"if\",\"t\",\"shared/ui/button\",\"payment/stripe-payment-element\",\"not\",\"perform\"]]",
    "moduleName": "checkout/components/payment/payment-method/index.hbs",
    "isStrictMode": false
  });
  let PaymentMethodComponent = _exports.default = (_class = class PaymentMethodComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "stripe", _descriptor, this);
      _initializerDefineProperty(this, "alerts", _descriptor2, this);
      _initializerDefineProperty(this, "payment", _descriptor3, this);
      _initializerDefineProperty(this, "intl", _descriptor4, this);
      /**
       * Note: Editing only available for users managing an existing subscription
       */
      _initializerDefineProperty(this, "isEditing", _descriptor5, this);
      _initializerDefineProperty(this, "isPaymentMethodComplete", _descriptor6, this);
      _initializerDefineProperty(this, "stripePaymentElementElements", _descriptor7, this);
      /**
       * The main form save
       */
      _defineProperty(this, "savePaymentElement", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          (false && !(this.stripePaymentElementElements) && (0, _debug.assert)('elements exists', this.stripePaymentElementElements));
          try {
            this.alerts.clear();
            const paymentMethod = yield this.stripe.confirmPaymentMethod(this.stripePaymentElementElements, 'checkout');
            this.toggleEditing();
            yield this.payment.updatePaymentMethod(paymentMethod.id, {
              location: 'checkout'
            });
            this.args.onStripePaymentElementSaved(paymentMethod);
            this.alerts.success(this.intl.t('alerts.account.subscription.billing.update_card.success'));
          } catch (error) {
            //Note: may show error if 3ds fails
            this.alerts.warning(error?.message);
            return;
          }
        }
      }), null, "savePaymentElement", "drop"));
    }
    get canSave() {
      return this.isEditing && this.isPaymentMethodComplete;
    }
    get isEditDisabled() {
      return this.args.isDisabled || this.savePaymentElement.isRunning;
    }
    get showSavedCard() {
      return Boolean(this.args.hasActiveSubscription && this.args.paymentMethod?.card?.last4 && !this.isEditing);
    }
    toggleEditing() {
      this.isEditing = !this.isEditing;
      if (!this.isEditing) {
        this.args.onStripePaymentElementChange({
          complete: false,
          empty: true,
          elements: undefined
        });
      }
    }

    /**
     *
     * Event when card changes from empty -> partially filled -> complete.
     */
    async onStripePaymentElementChange(arg) {
      const {
        complete,
        elements
      } = arg;
      this.isPaymentMethodComplete = complete;
      this.stripePaymentElementElements = elements;

      //Note: Allow parent component to run it's own logic
      this.args.onStripePaymentElementChange(arg);
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "stripe", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "alerts", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "payment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "isEditing", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "isPaymentMethodComplete", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "stripePaymentElementElements", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "toggleEditing", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleEditing"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onStripePaymentElementChange", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "onStripePaymentElementChange"), _class.prototype)), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, PaymentMethodComponent);
});